import { render, staticRenderFns } from "./VipPay.vue?vue&type=template&id=19002830"
import script from "./VipPay.vue?vue&type=script&lang=js"
export * from "./VipPay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports